import { useState } from 'react'
import { RiUserLine } from 'react-icons/ri'
import { CONFIG } from '../../../../api/config'
import logo from '../../../../styles/icons/sm-hub-logo.svg'
import ButtonComponent from "../../button.component"
import { ConfirmModalComponent } from '../confirm.modal.component'
import * as styled from './styled'

interface LoginModalProps {
  onClose: () => void
}

export const LoginModalComponent = ({ onClose }: LoginModalProps) => {
 const [showConfirm, setShowConfirm] = useState(false);

  const handleProceedToConfirm = () => {
    const isSkipMode = localStorage.getItem('skipConfirmCabinet') === 'true';

    if (isSkipMode) {
      window.open(CONFIG.SMART_CITY, '_blank', 'noopener,noreferrer');
      onClose(); 
    } else {
      setShowConfirm(true);
    }
  };

  if (showConfirm) {
    return (
      <ConfirmModalComponent
        onClose={onClose} 
        onBack={() => setShowConfirm(false)} 
      />
    );
  }
  return (
      <>
      <styled.LoginOverlay 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose} />
      <styled.LoginModalContainer
      initial={{ opacity: 0, scale: 0.9, y: -10 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.9, y: -10 }}
      transition={{ type: "spring", duration: 0.4, bounce: 0.3 }}>
        <styled.UserCircleInModal>
          <RiUserLine size={24} color='#01924f' />
        </styled.UserCircleInModal>

        <styled.LoginModalWrapper>
          <img src={logo} alt="logo" />
          <styled.LoginModalText>
            Вхід через Кабінет Мешканця вебпорталу «Цифрове Запоріжжя»
          </styled.LoginModalText>
          <styled.LoginModalActions>
            <ButtonComponent
              text='Увійти'
              position='bottom-right'
              onClick={handleProceedToConfirm}
            />
            <ButtonComponent
              text='Скасувати'
              variant='outline'
              position='top-right'
              onClick={onClose}
            />
          </styled.LoginModalActions>
        </styled.LoginModalWrapper>
      </styled.LoginModalContainer>
    </>
  )
}